// ========================================
// Widget: RRHH — Justificantes recientes
// Los últimos justificantes recibidos (personal y alumnado); punto ámbar = sin revisar.
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

window.DashboardWidgets.rrhh.justificantesRecientes = function(ctx) {
    const { recentDocs = [], justificantesNew = 0 } = ctx;
    const W = window.DashboardWidgets.rrhh;
    const today = new Date().toISOString().slice(0, 10), yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
    const when = iso => iso === today ? 'Hoy' : iso === yesterday ? 'Ayer' : W.shortDate(iso);
    const rows = recentDocs.length ? recentDocs.map(d => `
        <div class="rp-row" style="flex-wrap: nowrap;">
            <span class="rp-dot ${d.isNew ? 'is-new' : ''}" aria-label="${d.isNew ? 'Sin revisar' : 'Revisado'}"></span>
            <span class="rp-row-text"><span class="rp-row-name">${Utils.sanitizeHTML(d.name)}</span><span class="rp-row-detail">${Utils.sanitizeHTML(d.detail)}</span></span>
            <span class="rp-muted" style="white-space: nowrap;">${when(d.date)}</span>
        </div>`).join('') : '<div class="rp-empty">Aún no hay justificantes.</div>';
    const inner = `
        <div class="rp-card-head">
            <h2 class="rp-card-title">Justificantes recientes</h2>
            <span style="display: inline-flex; gap: 0.6rem; align-items: baseline;">
                ${justificantesNew ? `<span class="rp-badge is-warn">${justificantesNew} sin revisar</span>` : ''}
                <button type="button" class="rp-card-link" ${UIEvents.attr("click", function(event,captured){App.navigate('justificantes');}, [])}>Ver todos</button>
            </span>
        </div>
        <div>${rows}</div>`;
    return W.card(ctx, inner);
};
